import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { clone, KreFormFieldConfig } from "@kre-form/core";
import { IBusinessTable } from "../../tools/util";
import { DataService } from "../../service/data.service";
import * as _ from "lodash";

@Component({
  selector: "kreform-design-tables",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.less"],
  providers: [DataService],
})
export class KreFormDesignTables implements OnInit, OnChanges, OnDestroy {
  @Input() businessTable: IBusinessTable = {
    primary: {},
    child: {
      single: [],
      multiple: [],
    },
  };
  radioValue = "";
  tableData = []; 
  constructor() {}
  tableScroll = {
    y: "360px",
  };
  ngOnInit() {
    this.initTableData();
  }

  ngOnChanges(changes: SimpleChanges) {}

  ngOnDestroy() {}

  initTableData() {
    this.tableData = [];
    let business = clone(this.businessTable);
    let tables: any = [];
    if (!business) return;
    if (
      business.child &&
      business.child != null &&
      business.child.multiple &&
      business.child.multiple != null &&
      business.child.multiple.length > 0
    ) {
      this.tableData = business.child.multiple;
    }
  }

  selectOK(table: any) {}
}
